<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['Offer Types', editMode ? offerName : 'Add New']"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="offer-type-edit-title">Title</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="offerTypeData.name"
                  name="title"
                  #title="ngModel"
                  class="form-control"
                  id="offer-type-edit-title"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(title.touched || title.dirty) && !title.valid">
                  Title {{ errors['name'] || 'is invalid.' }}
                </small>
              </div>

              <div class="form-group">
                <label for="offer-type-edit-position">Position</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="offerTypeData.position"
                  name="position"
                  #position="ngModel"
                  class="form-control"
                  id="offer-type-edit-position"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(position.touched || position.dirty) && !position.valid">
                  Position {{ errors['position'] || 'is invalid.' }}
                </small>
              </div>

              <div class="form-group">
                <label for="offer-type-edit-position">Images (390x390)</label>
                <div class="row">
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="homeIconChanged($event)"
                      [resourceId]="offerTypeData.homeIconId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="homeIconSelectedChanged($event)"
                      [resourceId]="offerTypeData.homeIconSelectedId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="searchIconChanged($event)"
                      [resourceId]="offerTypeData.searchIconId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="searchIconSelectedChanged($event)"
                      [resourceId]="offerTypeData.searchIconSelectedId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                </div>
              </div>

              <div class="text-danger">{{ error }}</div>

              <div style="margin-top: 40px;">
                <button id='offerTypeEditDelete' *ngIf="editMode" type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <span class="btn-right">
                  <button id='offerTypeEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='offerTypeEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offer-types/offer-type-edit/offer-type-edit.component.html